"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _react = _interopRequireWildcard(require("react")),
    _Notifications = require("../../Notifications"),
    _Files = _interopRequireDefault(require("../components/Files"));

function handleError(a) {
  (0, _Notifications.notify)({
    content: a.message,
    type: "error"
  });
}

function Files(a) {
  return _react["default"].createElement(_Notifications.NotificationsProvider, null, _react["default"].createElement(_Files["default"], (0, _extends2["default"])({}, a, {
    onFilesError: handleError
  })));
}

var _default = (0, _react.memo)(Files);

exports["default"] = _default;